var FloorPlanEntities;
(function (FloorPlanEntities) {
    FloorPlanEntities["SOURCE"] = "source";
    FloorPlanEntities["GATEWAY"] = "gateway";
    FloorPlanEntities["EQUIPMENT"] = "asset";
    FloorPlanEntities["EMPTY"] = "empty";
})(FloorPlanEntities || (FloorPlanEntities = {}));
export default FloorPlanEntities;
